<template>
  <a-modal
    title="审核资金提现"
    :visible="visible"
    :confirm-loading="loading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :maskClosable="false"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-model-item label="审核状态" prop="withdrawalState">
        <a-select v-model="form.withdrawalState" placeholder="请选择审核状态" style="width: 100%">
          <a-select-option :value="2">审核通过</a-select-option>
          <a-select-option :value="3">审核不通过</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="审核不通过原因" prop="withdrawalReason" v-if="form.withdrawalState === 3">
        <a-input
          v-model="form.withdrawalReason"
          type="textarea"
          :rows="4"
          placeholder="请输入审核不通过原因"
          :max-length="200"
          show-word-limit
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { auditWithdrawal } from '@/api/pressure/fund'

export default {
  name: 'AuditModal',
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        id: undefined,
        withdrawalState: undefined,
        withdrawalReason: '',
      },
      rules: {
        withdrawalState: [{ required: true, message: '请选择审核状态', trigger: 'change' }],
        withdrawalReason: [
          {
            validator: (rule, value, callback) => {
              if (this.form.withdrawalState === 3 && !value) {
                callback(new Error('请输入审核不通过原因'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    init(record) {
      this.form = {
        id: record.id,
        withdrawalState: undefined,
        withdrawalReason: '',
      }
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.form = {
        id: undefined,
        withdrawalState: undefined,
        withdrawalReason: '',
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            id: this.form.id,
            withdrawalState: this.form.withdrawalState,
            withdrawalReason: this.form.withdrawalState === 3 ? this.form.withdrawalReason : undefined,
          }
          this.loading = true
          auditWithdrawal(params)
            .then((res) => {
              if (res.success) {
                this.$message.success('审核成功')
                this.handleCancel()
                this.$emit('success')
              } else {
                this.$message.error(res.message || '审核失败')
              }
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
  },
}
</script>
